import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import { shoppingCartCountSelector } from 'app/selectors/propertyHighlight'
import { IonIcon } from 'controls/index'
import ContractFeaturesFlag from 'components/ContractFeaturesFlag'
import { CONTRACT_FEATURES } from 'app/constants/contractFeatures'

import { iconStyles } from './styles'

function ShoppingCardIcon() {
  const shoppingCartLength = useSelector(shoppingCartCountSelector)
  const router = useRouter()

  const isShoppingCartPage =
    router.pathname === '/dashboard/properties/highlight-checkout'

  const isShoppingCartEmpty = shoppingCartLength === 0

  function goToShoppingCart() {
    if (!isShoppingCartPage && !isShoppingCartEmpty) {
      router.push('/dashboard/properties/highlight-checkout')
    }
  }

  return (
    <ContractFeaturesFlag
      contractFeature={CONTRACT_FEATURES.PROPERTY_HIGHLIGHT_ON_DEMAND}
    >
      <IonIcon
        className={classNames('shoppingCardIcon shoppingCardIconBadge', {
          disabled: isShoppingCartEmpty,
        })}
        data-badge={shoppingCartLength || null}
        size="medium"
        icon="ios-cart"
        onClick={goToShoppingCart}
      />
      <style jsx>{iconStyles}</style>
    </ContractFeaturesFlag>
  )
}

export default ShoppingCardIcon
